<template>
  <v-row id="paymentAndBillingSettings">
    <v-col md="12" cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-text>
          <v-row>
            <!-- Payment Method Section -->
            <v-col cols="12" md="6" class="py-0">
              <div class="body-heading-medium mb-5">Payment Methods</div>
              <PaymentMethodForm v-if="isPaymentMethodFormShown || forceShowPaymentForm" @force-close="closePaymentMethodForm" />
              <v-item-group v-else>
                <v-row no-gutters>
                  <v-col v-for="paymentMethodInfo in paymentMethods" :key="paymentMethodInfo.id" cols="12" md="12" class="py-4">
                    <v-item>
                      <v-card outlined>
                        <v-card-text>
                          <v-row no-gutters>
                            <!-- Payment card information -->
                            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start">
                              <PaymentMethodListItem :paymentMethod="paymentMethodInfo" />
                            </v-col>
                            <!-- Actions -->
                            <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
                              <DeletePaymentMethodModal :paymentMethodId="paymentMethodInfo.id" />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                  <v-col cols="12" md="12" class="d-flex justify-md-end justify-center">
                    <v-btn @click="showPaymentMethodForm" text class="add-payment-method-btn">
                      + Add New Payment Method
                    </v-btn>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-col>
            <!-- Payment History Section -->
            <v-col cols="12" md="6" class="py-0">
              <div class="body-heading-medium mb-5">Payment History</div>
              <PaymentHistory />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import PaymentMethodForm from "@/components/Payment/PaymentMethodForm";
  import PaymentMethodListItem from "@/components/Payment/PaymentMethodListItem";
  import DeletePaymentMethodModal from "@/components/Payment/DeletePaymentMethodModal";
  import PaymentHistory from "@/components/Payment/PaymentHistory";

  export default {
    name: "PaymentAndBillingSettings",
    data() {
      return {
        forceShowPaymentForm: undefined,
      };
    },
    computed: {
      paymentMethods() {
        return this.$store.getters.getPaymentMethods();
      },
      isPaymentMethodFormShown() {
        if (!this.$validator.isEmptyArray(this.paymentMethods)) {
          return false;
        }
        return true;
      },
    },
    components: {
      PaymentMethodForm,
      PaymentMethodListItem,
      DeletePaymentMethodModal,
      PaymentHistory,
    },
    methods: {
      reset() {
        this.forceShowPaymentForm = undefined;
      },
      closePaymentMethodForm() {
        this.forceShowPaymentForm = false;
      },
      showPaymentMethodForm() {
        //This is not good
        this.forceShowPaymentForm = true;
      },
    },
    created() {
      this.$store.commit("setLoadingStatus", true);

      this.$http
        .get("/cards")
        .then((response) => {
          this.$store.commit("addPaymentMethods", response.data.data);

          this.$store.commit("setLoadingStatus", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: this.$formatter.getErrorMsg(error),
            type: "error",
          });
          this.$store.commit("setLoadingStatus", false);
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GeneralSettings/PaymentAndBillingSettings.vue